import { render, staticRenderFns } from "./iconMap.vue?vue&type=template&id=70594032"
import script from "./iconMap.vue?vue&type=script&lang=js"
export * from "./iconMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports